/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apr_GInputs */

const en_mk_tut_apr_g = /** @type {(inputs: Mk_Tut_Apr_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent may draft anything inside the workspace. But the moment an action leaves the company — sending, posting, paying — it has to ask first.`)
};

const id_mk_tut_apr_g = /** @type {(inputs: Mk_Tut_Apr_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen boleh menyusun apa pun di dalam ruang kerja. Tapi begitu tindakannya keluar dari perusahaan — mengirim, memposting, membayar — ia harus minta izin dulu.`)
};

/**
* | output |
* | --- |
* | "An agent may draft anything inside the workspace. But the moment an action leaves the company — sending, posting, paying — it has to ask first." |
*
* @param {Mk_Tut_Apr_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apr_g = /** @type {((inputs?: Mk_Tut_Apr_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apr_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apr_g(inputs)
	return en_mk_tut_apr_g(inputs)
});